import { AnimatePresence, motion } from "framer-motion"
import type { AnimationDefinition } from "framer-motion"
import type React from "react"
import styled from "styled-components"
import { ERROR_ANIMATION_VARIANTS } from "../animation"
import useSleep from "../hooks/useSleep"

interface WrapperProps {
  offsetX?: string
  offsetY?: string
}
const Wrapper = styled(motion.div)<WrapperProps>`
  position: absolute;
  top: ${(props) => props.offsetY};
  right: ${(props) => props.offsetX};
  will-change: transform;

  color: ${(props) => props.theme.colors.error};
  font-size: 0.7rem;
  white-space: nowrap;
`

export type ComponentErrorAnimationVariant = "visible" | "hidden"

interface ComponentErrorProps {
  className?: string

  error?: string | null
  hide?: boolean
  offsetX?: string
  offsetY?: string
  timeout?: number

  onTimeout?: (variant: ComponentErrorAnimationVariant) => void
}

export const ComponentError: React.FC<ComponentErrorProps> = ({
  className,

  error,
  hide = false,
  offsetX = "0",
  offsetY = "0",
  timeout,

  onTimeout,
}) => {
  const sleep = useSleep()

  async function handleAnimationComplete(def: AnimationDefinition) {
    if (!timeout || !error || typeof def !== "string") return

    await sleep(timeout)
    onTimeout?.(def as ComponentErrorAnimationVariant)
  }

  return (
    <AnimatePresence>
      {!hide && !!error && (
        <Wrapper
          className={className}
          variants={ERROR_ANIMATION_VARIANTS}
          initial="hidden"
          animate="visible"
          exit="hidden"
          offsetX={offsetX}
          offsetY={offsetY}
          onAnimationComplete={handleAnimationComplete}
        >
          {error}
        </Wrapper>
      )}
    </AnimatePresence>
  )
}
